import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=231f3248"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FiltersV2ComponentSort: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/filters/v2/Component/Sort.vue').default})
